import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/sos-logo.png'


const _hoisted_1 = { class: "logging-bg flex h-screen" }
const _hoisted_2 = { class: "flex flex-col-reverse md:flex-row shadow-xl rounded-lg m-auto overflow-hidden" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-extralight my-2 mb-4" }, " Aquí podrás visualizar todas las comunidades asociadas a tu cuenta. Para continuar, debes seleccionar la comunidad en la que quieres trabajar y presionar el botón \"Continuar\". ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-extralight my-2 mb-4" }, " Recuerda que si quieres cambiar de cuenta o contraseña puedes seleccionar \"Volver al login\", que se encuentra a continuación. ", -1)
const _hoisted_5 = { class: "bg-white py-4 px-10 md:w-80 flex flex-col gap-2 items-center justify-center" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-primary-500 border-success" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "bg-black bg-opacity-60 p-4 md:w-72 flex flex-col justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "flex",
    src: _imports_0,
    alt: "logo beepi"
  })
], -1)

import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "../../stores/auth";
import { AuthService } from "@/services/auth/AuthServices";
import { CommunityService } from "@/services/communities/CommunityServices";

import { swal as Swal } from "@/configs/swal";

import Selector from "@/components/general/atoms/Selector.vue";
import AppButton from "@/components/general/atoms/AppButton.vue";

interface Community {
  value: any;
  label: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BlockList',
  setup(__props) {

const communityService = new CommunityService();
const router = useRouter();
const authService = new AuthService();
const authStore = useAuthStore();
const communityId = ref<number>(0);
const blockId = ref<number>(0);
const showAlert = ref<boolean>(false);

const buildingCommunities = ref<Community[]>([]);
const buildingBlocks = ref<Community[]>([]);

const buildingBlocksIsPending = ref<boolean | undefined>(undefined);
const buildingCommunitiesIsPending = ref<boolean | undefined>(undefined);

const pending = computed(
  () => buildingBlocksIsPending.value || buildingCommunitiesIsPending.value
);
const disableSubmit = computed(
  () =>
    buildingBlocksIsPending.value ||
    buildingCommunitiesIsPending.value ||
    communityId.value == undefined ||
    communityId.value == 0 ||
    blockId.value == undefined ||
    blockId.value == 0
);

const init = async () => {
  buildingCommunities.value = [];
  buildingCommunitiesIsPending.value = true;
  const response = await communityService.getCommunitiesUser();

  if (response.code === 200) {
    if (response.data.length > 0) {
      // Eliminar duplicados por id y ordenar alfabéticamente la lista
      const uniqueCommunities = Array.from(
        new Map(
          response.data.map((obj: { id: any; name: any }) => [obj.id, obj])
        ).values()
      ) as { id: any; name: any }[];
      
      buildingCommunities.value = uniqueCommunities
        .map((obj: { id: any; name: any }): Community => {
          return {
            value: obj.id,
            label: obj.name,
          };
        })
        .sort((a: Community, b: Community) => {
          return a.label.localeCompare(b.label, 'es', { sensitivity: 'base' });
        });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Este usuario no tiene una comunidad asociada",
      });
    }
  }
  buildingCommunitiesIsPending.value = false;

  setTimeout(() => {
    showAlert.value = false;
  }, 4000);
};

const obtainBlockId = async (value: any) => {
  buildingBlocks.value = [];
  buildingBlocksIsPending.value = true;
  communityId.value = value;
  blockId.value = 0; 
  const authToken = authStore.userSession;
  if (authToken && communityId.value) {
    const response = await communityService.getComunityUser(
      communityId.value,
      authToken?.userId
    );

    if (response.code === 200) {
      authStore.setCommunityUser(response.data);
      
      let blocksResponse = await communityService.getCommunityBlocks(
        response.data.communityId,
        response.data.id
      );
      
      if (blocksResponse.code !== 200 || !blocksResponse.data || blocksResponse.data.length === 0) {
        blocksResponse = await communityService.getBlockCommunity(
          response.data.communityId
        );
      }
      
      if (blocksResponse.code === 200 && blocksResponse.data && blocksResponse.data.length > 0) {

        blockId.value = blocksResponse.data[0].id;
        buildingBlocks.value = blocksResponse.data.map(
          (obj: { id: any; name: any }) => {
            return {
              value: obj.id,
              label: obj.name,
            };
          }
        );
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Esta comunidad no tiene blocks asociados",
        });
      }
    }
  } else {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Usuario no registrado o sin comunidad asociada, redirigiendo a login",
    });

    router.push("/");
  }

  buildingBlocksIsPending.value = false;
};

const goHomePage = async () => {
  router.push({
    path: `/community/${communityId.value}/block/${blockId.value}/home`,
  });
};


const back = async () => {
  const authToken = authStore.token as string;
  try {
    await authService.logout(authToken);
    authStore.logout();
    router.push("/");
  } catch (error) {
    console.error(error);
  }
};

onMounted(async () => {
  await init();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { class: "bg-black bg-opacity-60 p-4 md:w-72 flex flex-col" }, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("button", {
          class: "px-4 py-2 text-white font-bold mx-auto underline underline-offset-4",
          onClick: back
        }, " Volver al Login ")
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(Selector, {
          selectedItem: communityId.value,
          label: 'Comunidades del usuario',
          placeHolder: 'Seleccione una Comunidad',
          class: "w-full gap-4",
          onUpdate: obtainBlockId,
          items: buildingCommunities.value
        }, null, 8, ["selectedItem", "items"]),
        _createVNode(AppButton, {
          itsDisabled: _unref(disableSubmit),
          text: "Continuar",
          uppercase: true,
          onClick: goHomePage,
          class: "bg-green-500 text-white mt-4"
        }, null, 8, ["itsDisabled"]),
        (_unref(pending))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
          : _createCommentVNode("", true)
      ]),
      _hoisted_9
    ])
  ]))
}
}

})